import {Switch} from 'platform/components';
import {VStack} from 'platform/foundation';

import {isBoolean} from 'ramda-adjunct';

import {suffixTestId} from 'shared/web';

import {FILTER_VALUE_KEY} from '../../constants/filterValueKey';
import type {EagFilterProps} from '../../types/EagFilterProps';
import {getQuickFilterFromString} from '../../utils/quickFilterValue';
import {QuickFilterChips} from '../QuickFilterChips/QuickFilterChips';

type SwitchFilterProps = EagFilterProps & {
  quickFilters?: Array<{value: string; label: string}>;
};

export function SwitchFilter(props: SwitchFilterProps) {
  const model = props.value[FILTER_VALUE_KEY] as string | boolean | null;

  const setValue = (newModel: string | boolean | null) => {
    props.onChange({[FILTER_VALUE_KEY]: newModel ?? null});
  };

  const onChange = (value: boolean) => {
    setValue(value);
  };

  const isQuickFilterValue = getQuickFilterFromString(model);
  const isValue = isBoolean(model) ? model : false;

  return (
    <VStack spacing={2}>
      <QuickFilterChips
        quickFilters={props.quickFilters}
        value={isQuickFilterValue}
        defaultValue={false}
        setFilterValue={setValue}
        isDisabled={props.isDisabled}
        data-testid={suffixTestId('switch-filter-quickFilters', props)}
      />
      <Switch
        isDisabled={props.isDisabled}
        value={isValue}
        onChange={onChange}
        data-testid={suffixTestId('switch-filter', props)}
      />
    </VStack>
  );
}
